/**
 * Stable CSS class names for E2E — Customer Anonymization (+ History screen).
 */
export const CAN = {
    mainPage: 'customer-anonymization-page',
    mainTitle: 'customer-anonymization-page__title',
    mainSearch: 'customer-anonymization-page__search',
    mainGrid: 'customer-anonymization-page__datagrid',
    mainAnonymizeAction: 'customer-anonymization-field--anonymize-action',

    histPage: 'customer-anonymization-history-page',
    histTitle: 'customer-anonymization-history-page__title',
    histSearch: 'customer-anonymization-history-page__search',
    histGrid: 'customer-anonymization-history-page__datagrid',

    inputComposite: 'customer-anonymization-input--composite-search',
} as const;

export const canCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
